import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('../views/clcokInHome/index.vue'),
    redirect: '/attendance-Overview', 
    children: [
      {
        path: '/attendance-Overview',
        name: 'attendanceOverview',
        meta: {
          needLogin: true,
          title: '考勤总览',
          icon: 'el-icon-s-data',
        },
        component: () => import('../views/attendance-overview/index.vue'),
      },
      {
        path: '/project-management',
        name: 'projectManagement',
        meta: {
          needLogin: true,
          title: '项目管理',
          icon: 'el-icon-location',
        },
        component: () => import('../views/project-management/index.vue'),
      },
      {
        path: '/employee-management',
        name: 'employeeManagement',
        meta: {
          needLogin: true,
          title: '员工管理',
          icon: 'el-icon-user-solid',
        },
        component: () => import('../views/employee-management/index.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      needLogin: false,
      title: '登录',
    },
    component: () => import('../views/login/index.vue'),
  },
  {
    path: '*',
    meta: {
      needLogin: false,
      title: '暂无此页面',
    },
    component: () => import('../views/empty-page/index.vue'),
  },
];
// 处理重复路由报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
export default router;
